import { createUseStyles } from 'react-jss';

import { FontWeight, mediaQuery } from '../../../styles';
import { ITheme } from '../../../styles/theme';

const useStyles = createUseStyles(
  ({ spacing, breakpoints, layout }: ITheme) => ({
    container: {
      padding: [0, '48px'],

      [mediaQuery(breakpoints.tablet)]: {
        padding: [0, '24px'],
      },
    },
    root: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'stretch',
      gap: '48px',

      padding: '72px 56px 56px',
      overflow: 'hidden',

      background: 'var(--x-bg-2)',
      borderRadius: '32px',

      maxWidth: layout.maxWidth,
      margin: 'auto',

      [mediaQuery(breakpoints.tablet)]: {
        padding: '32px 8px',
        gap: '32px',
      },
    },
    text: {
      flex: 1,

      [mediaQuery(breakpoints.tablet)]: {
        padding: '0 32px',
      },
    },
    title: {
      fontSize: '60px !important',
      fontWeight: `${FontWeight.Regular} !important`,
      marginBottom: '24px',
      textAlign: 'center',

      [mediaQuery(breakpoints.tablet)]: {
        fontSize: '42px !important',
        lineHeight: '42px !important',
      },
    },
    description: {
      fontSize: '16px !important',
      textAlign: 'center',
      maxWidth: '670px',
      margin: [0, 'auto'],
    },
    questions: {
      position: 'relative',
      flex: 2,
      width: '100%',

      display: 'flex',
      flexDirection: 'column',
      gap: spacing.xxLarge,
      alignItems: 'center',
    },
    hiddenQuestion: {
      display: 'none',
    },
    accordion: {
      width: '100%',

      [mediaQuery(breakpoints.tablet)]: {
        padding: '0 16px',
      },
    },
    question: {
      width: '100%',

      padding: '32px',
      borderRadius: '32px',

      background: 'var(--x-bg-2)',
    },
    questionTitle: {
      fontSize: '24px !important',
      fontWeight: `${FontWeight.Regular} !important`,

      [mediaQuery(breakpoints.tablet)]: {
        fontSize: '16px !important',
      },
    },
    questionAnswer: {
      color: 'var(--x-text-color-2)',
      fontSize: '16px !important',
    },
  }),
  {
    name: 'faq-centred-section',
  },
);

export default useStyles;
